<div class="stepper-container">
    <div>
        <div class="step-content" style="align-items: center;">
          <div class="step-title">
              <div class="Label" style="color: rgba(0, 0, 0, 0.87); font-size: 24px; font-family: Roboto; font-weight: 400; line-height: 32.02px; word-wrap: break-word">Select a user type</div>
          </div>
      <form [formGroup]="selectUserType">
          <ng-template matStepLabel>User Type</ng-template>
          <mat-radio-group formControlName="userType"  aria-label="Select an option">
             
              
             
        <div class="row">
       
          <div style="cursor: pointer;" (click)="onSelectCard('1')"  [ngClass]="{'column-card-types': registerAs != '4' ,'column-card': registerAs != '1' ,'column-card-selected': registerAs == '1'   }">
    <div class="column-card-body">
      <div class="column-card-body-content">
        <div [ngClass]="{'column-card-title-blue': registerAs != '1' ,'column-card-title-white': registerAs == '1'   }">
          <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
            <div style="width: 32px; height: 32px; position: relative">
              <mat-icon >person</mat-icon>
            </div>
          </div>
          <div style="align-self: stretch;  font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Individual property owner</div>
        </div>
        <div style="width: 24px; height: 24px; position: relative">
          <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
            <mat-radio-button class="matselectcard" [checked]="registerAs == '1'" (change)="radioChange($event)" color="primary"  value="1">
            </mat-radio-button>
          </div>
        </div>
      </div>
      <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div class="column-card-footer-title">You are the property owner and want to create an account to validate tax info or manage taxes by yourself.</div>
      </div>
    </div>
    </div>
    <div style="cursor: pointer;" (click)="onSelectCard('2')"  [ngClass]="{'column-card-types': registerAs != '4' ,'column-card': registerAs != '2' ,'column-card-selected': registerAs == '2'   }">
      <div class="column-card-body">
          <div class="column-card-body-content">
        <div [ngClass]="{'column-card-title-blue': registerAs != '2' ,'column-card-title-white': registerAs == '2'   }">
          <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
            <div style="width: 32px; height: 32px; position: relative">
              <mat-icon >location_city</mat-icon>
            </div>
          </div>
          <div style="align-self: stretch;  font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Property management company</div>
        </div>
        <div style="width: 24px; height: 24px; position: relative">
          <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
            <mat-radio-button class="matselectcard"[checked]="registerAs == '2'" (change)="radioChange($event)" color="primary"  value="2">
            </mat-radio-button>
          </div>
        </div>
      </div>
      <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div class="column-card-footer-title">This category is suitable for companies responsible for maintaining properties, collecting rent, and handling tenant relations on behalf of property owners.</div>
      </div>
    </div>
    </div>
    
    <div style="cursor: pointer;" (click)="onSelectCard('3')"   [ngClass]="{'column-card-types': registerAs != '4' ,'column-card': registerAs != '3' ,'column-card-selected': registerAs == '3'   }">
      <div class="column-card-body">
          <div class="column-card-body-content">
        <div [ngClass]="{'column-card-title-blue': registerAs != '3' ,'column-card-title-white': registerAs == '3'   }">
          <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
            <div style="width: 32px; height: 32px; position: relative">
              <mat-icon>hotel</mat-icon>
            </div>
          </div>
          <div style="align-self: stretch; font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">Bed & breakfast / Hotel / Motel</div>
        </div>
        <div style="width: 24px; height: 24px; position: relative">
          <div style="width: 20px; height: 20px; left: 2px; top: 2px; position: absolute;">
            <mat-radio-button class="matselectcard"[checked]="registerAs == '3'" (change)="radioChange($event)" color="primary" value="3">
            </mat-radio-button>
          </div>
        </div>
      </div>
      <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div class="column-card-footer-title">Select this option if you provide lodging services. This category is ideal for businesses offering short-term accommodations.</div>
      </div>
    </div>
    
    </div>
        </div>
     
        </mat-radio-group>
        </form>
      </div>
       </div>
</div>

<div style="position: fixed; bottom: 0;width: 100%;background-color: white;">
  <div class="button-stepper-footer">
    <button   mat-stroked-button mat-button class="button-stepper-cancel" (click)="onCancelClick()">CANCEL<mat-icon>close</mat-icon></button>

    <button [disabled]="!selectUserType.valid"  [ngClass]="{'button-stepper-allow': selectUserType.valid ,'button-stepper': selectUserType.invalid  }" mat-stroked-button mat-button (click)="redirectTo()" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
 
  </div>
  </div>